module.exports = __webpack_public_path__ + "static/media/TemplateBase.9567fef8.png";